export default {
  'pl': {
    'PL': 'Polska',
    '': '---------------------------',
    'AF': 'Afganistan',
    'AL': 'Albania',
    'DZ': 'Algieria',
    'AS': 'Samoa Amerykańskie',
    'AD': 'Andora',
    'AO': 'Angola',
    'AI': 'Anguilla',
    'AQ': 'Antarktyka',
    'AG': 'Antigua i Barbuda',
    'AR': 'Argentyna',
    'AM': 'Armenia',
    'AW': 'Aruba',
    'AU': 'Australia',
    'AT': 'Austria',
    'AZ': 'Azerbejdżan',
    'BS': 'Bahamy',
    'BH': 'Bahrajn',
    'BD': 'Bangladesz',
    'BB': 'Barbados',
    'BY': 'Białoruś',
    'BE': 'Belgia',
    'BZ': 'Belize',
    'BJ': 'Benin',
    'BM': 'Bermudy',
    'BT': 'Bhutan',
    'BO': 'Boliwia',
    'BA': 'Bośnia i Hercegowina',
    'BW': 'Botswana',
    'BV': 'Wyspa Bouveta',
    'BR': 'Brazylia',
    'IO': 'Brytyjskie Terytorium Oceanu Indyjskiego',
    'BN': 'Brunei',
    'BG': 'Bułgaria',
    'BF': 'Burkina Faso',
    'BI': 'Burundi',
    'KH': 'Kambodża',
    'CM': 'Kamerun',
    'CA': 'Kanada',
    'CV': 'Republika Zielonego Przylądka',
    'KY': 'Kajmany',
    'CF': 'Republika Środkowoafrykańska',
    'TD': 'Czad',
    'CL': 'Chile',
    'CN': 'Chiny',
    'CX': 'Wyspa Bożego Narodzenia',
    'CC': 'Wyspy Kokosowe',
    'CO': 'Kolumbia',
    'KM': 'Komory',
    'CG': 'Kongo',
    'CD': 'Demokratyczna Republika Konga',
    'CK': 'Wyspy Cooka',
    'CR': 'Kostaryka',
    'CI': 'Wybrzeże Kości Słoniowej',
    'HR': 'Chorwacja',
    'CU': 'Kuba',
    'CY': 'Cypr',
    'CZ': 'Czechy',
    'DK': 'Dania',
    'DJ': 'Dżibuti',
    'DM': 'Dominika',
    'DO': 'Dominikana',
    'EC': 'Ekwador',
    'EG': 'Egipt',
    'SV': 'Salwador',
    'GQ': 'Gwinea Równikowa',
    'ER': 'Erytrea',
    'EE': 'Estonia',
    'ET': 'Etiopia',
    'FK': 'Falklandy',
    'FO': 'Wyspy Owcze',
    'FJ': 'Fidżi',
    'FI': 'Finlandia',
    'FR': 'Francja',
    'GF': 'Gujana Francuska',
    'PF': 'Polinezja Francuska',
    'TF': 'Francuskie Terytoria Południowe i Antarktyczne',
    'GA': 'Gabon',
    'GM': 'Gambia',
    'GE': 'Gruzja',
    'DE': 'Niemcy',
    'GH': 'Ghana',
    'GI': 'Gibraltar',
    'GR': 'Grecja',
    'GL': 'Grenlandia',
    'GD': 'Grenada',
    'GP': 'Gwadelupa',
    'GU': 'Guam',
    'GT': 'Gwatemala',
    'GN': 'Gwinea',
    'GW': 'Gwinea Bissau',
    'GY': 'Gujana',
    'HT': 'Haiti',
    'HM': 'Wyspy Heard i McDonalda',
    'VA': 'Watykan',
    'HN': 'Honduras',
    'HK': 'Hongkong',
    'HU': 'Węgry',
    'IS': 'Islandia',
    'IN': 'Indie',
    'ID': 'Indonezja',
    'IR': 'Iran',
    'IQ': 'Irak',
    'IE': 'Irlandia',
    'IL': 'Izrael',
    'IT': 'Włochy',
    'JM': 'Jamajka',
    'JP': 'Japonia',
    'JO': 'Jordania',
    'KZ': 'Kazachstan',
    'KE': 'Kenia',
    'KI': 'Kiribati',
    'KP': 'Korea Północna',
    'KR': 'Korea Południowa',
    'KW': 'Kuwejt',
    'KG': 'Kirgistan',
    'LA': 'Laos',
    'LV': 'Łotwa',
    'LB': 'Liban',
    'LS': 'Lesotho',
    'LR': 'Liberia',
    'LY': 'Libia',
    'LI': 'Liechtenstein',
    'LT': 'Litwa',
    'LU': 'Luksemburg',
    'MO': 'Makau',
    'MK': 'Macedonia Północna',
    'MG': 'Madagaskar',
    'MW': 'Malawi',
    'MY': 'Malezja',
    'MV': 'Malediwy',
    'ML': 'Mali',
    'MT': 'Malta',
    'MH': 'Wyspy Marshalla',
    'MQ': 'Martynika',
    'MR': 'Mauretania',
    'MU': 'Mauritius',
    'YT': 'Majotta',
    'MX': 'Meksyk',
    'FM': 'Mikronezja',
    'MD': 'Mołdawia',
    'MC': 'Monako',
    'MN': 'Mongolia',
    'MS': 'Montserrat',
    'MA': 'Maroko',
    'MZ': 'Mozambik',
    'MM': 'Mjanma',
    'NA': 'Namibia',
    'NR': 'Nauru',
    'NP': 'Nepal',
    'NL': 'Holandia',
    'NC': 'Nowa Kaledonia',
    'NZ': 'Nowa Zelandia',
    'NI': 'Nikaragua',
    'NE': 'Niger',
    'NG': 'Nigeria',
    'NU': 'Niue',
    'NF': 'Norfolk',
    'MP': 'Mariany Północne',
    'NO': 'Norwegia',
    'OM': 'Oman',
    'PK': 'Pakistan',
    'PW': 'Palau',
    'PS': 'Palestyna',
    'PA': 'Panama',
    'PG': 'Papua-Nowa Gwinea',
    'PY': 'Paragwaj',
    'PE': 'Peru',
    'PH': 'Filipiny',
    'PN': 'Pitcairn',
    'PT': 'Portugalia',
    'PR': 'Portoryko',
    'QA': 'Katar',
    'RE': 'Reunion',
    'RO': 'Rumunia',
    'RU': 'Rosja',
    'RW': 'Rwanda',
    'SH': 'Wyspa Świętej Heleny, Wyspa Wniebowstąpienia i Tristan da Cunha',
    'KN': 'Saint Kitts i Nevis',
    'LC': 'Saint Lucia',
    'PM': 'Saint-Pierre i Miquelon',
    'VC': 'Saint Vincent i Grenadyny',
    'WS': 'Samoa',
    'SM': 'San Marino',
    'ST': 'Wyspy Świętego Tomasza i Książęca',
    'SA': 'Arabia Saudyjska',
    'SN': 'Senegal',
    'SC': 'Seszele',
    'SL': 'Sierra Leone',
    'SG': 'Singapur',
    'SK': 'Słowacja',
    'SI': 'Słowenia',
    'SB': 'Wyspy Salomona',
    'SO': 'Somalia',
    'ZA': 'Południowa Afryka',
    'GS': 'Georgia Południowa i Sandwich Południowy',
    'ES': 'Hiszpania',
    'LK': 'Sri Lanka',
    'SD': 'Sudan',
    'SR': 'Surinam',
    'SJ': 'Svalbard i Jan Mayen',
    'SZ': 'Suazi',
    'SE': 'Szwecja',
    'CH': 'Szwajcaria',
    'SY': 'Syria',
    'TW': 'Tajwan',
    'TJ': 'Tadżykistan',
    'TZ': 'Tanzania',
    'TH': 'Tajlandia',
    'TL': 'Timor Wschodni',
    'TG': 'Togo',
    'TK': 'Tokelau',
    'TO': 'Tonga',
    'TT': 'Trynidad i Tobago',
    'TN': 'Tunezja',
    'TR': 'Turcja',
    'TM': 'Turkmenistan',
    'TC': 'Turks i Caicos',
    'TV': 'Tuvalu',
    'UG': 'Uganda',
    'UA': 'Ukraina',
    'AE': 'Zjednoczone Emiraty Arabskie',
    'GB': 'Wielka Brytania',
    'US': 'Stany Zjednoczone',
    'UM': 'Dalekie Wyspy Mniejsze Stanów Zjednoczonych',
    'UY': 'Urugwaj',
    'UZ': 'Uzbekistan',
    'VU': 'Vanuatu',
    'VE': 'Wenezuela',
    'VN': 'Wietnam',
    'VG': 'Brytyjskie Wyspy Dziewicze',
    'VI': 'Wyspy Dziewicze Stanów Zjednoczonych',
    'WF': 'Wallis i Futuna',
    'EH': 'Sahara Zachodnia',
    'YE': 'Jemen',
    'ZM': 'Zambia',
    'ZW': 'Zimbabwe',
    'AX': 'Wyspy Alandzkie',
    'BQ': 'Bonaire, Sint Eustatius i Saba',
    'CW': 'Curaçao',
    'GG': 'Guernsey',
    'IM': 'Wyspa Man',
    'JE': 'Jersey',
    'ME': 'Czarnogóra',
    'BL': 'Saint-Barthélemy',
    'MF': 'Saint-Martin',
    'RS': 'Serbia',
    'SX': 'Sint Maarten',
    'SS': 'Sudan Południowy',
    'XK': 'Kosowo'
  },
  'en': {
    'GB': 'United Kingdom',
    '': '---------------------------',
    'AF': 'Afghanistan',
    'AL': 'Albania',
    'DZ': 'Algeria',
    'AS': 'American Samoa',
    'AD': 'Andorra',
    'AO': 'Angola',
    'AI': 'Anguilla',
    'AQ': 'Antarctica',
    'AG': 'Antigua and Barbuda',
    'AR': 'Argentina',
    'AM': 'Armenia',
    'AW': 'Aruba',
    'AU': 'Australia',
    'AT': 'Austria',
    'AZ': 'Azerbaijan',
    'BS': 'Bahamas',
    'BH': 'Bahrain',
    'BD': 'Bangladesh',
    'BB': 'Barbados',
    'BY': 'Belarus',
    'BE': 'Belgium',
    'BZ': 'Belize',
    'BJ': 'Benin',
    'BM': 'Bermuda',
    'BT': 'Bhutan',
    'BO': 'Bolivia',
    'BA': 'Bosnia and Herzegovina',
    'BW': 'Botswana',
    'BV': 'Bouvet Island',
    'BR': 'Brazil',
    'IO': 'British Indian Ocean Territory',
    'BN': 'Brunei Darussalam',
    'BG': 'Bulgaria',
    'BF': 'Burkina Faso',
    'BI': 'Burundi',
    'KH': 'Cambodia',
    'CM': 'Cameroon',
    'CA': 'Canada',
    'CV': 'Cape Verde',
    'KY': 'Cayman Islands',
    'CF': 'Central African Republic',
    'TD': 'Chad',
    'CL': 'Chile',
    'CN': 'China',
    'CX': 'Christmas Island',
    'CC': 'Cocos (Keeling) Islands',
    'CO': 'Colombia',
    'KM': 'Comoros',
    'CG': 'Congo',
    'CD': 'Congo, the Democratic Republic of the',
    'CK': 'Cook Islands',
    'CR': 'Costa Rica',
    'CI': 'Cote D\'Ivoire',
    'HR': 'Croatia',
    'CU': 'Cuba',
    'CY': 'Cyprus',
    'CZ': 'Czech Republic',
    'DK': 'Denmark',
    'DJ': 'Djibouti',
    'DM': 'Dominica',
    'DO': 'Dominican Republic',
    'EC': 'Ecuador',
    'EG': 'Egypt',
    'SV': 'El Salvador',
    'GQ': 'Equatorial Guinea',
    'ER': 'Eritrea',
    'EE': 'Estonia',
    'ET': 'Ethiopia',
    'FK': 'Falkland Islands (Malvinas)',
    'FO': 'Faroe Islands',
    'FJ': 'Fiji',
    'FI': 'Finland',
    'FR': 'France',
    'GF': 'French Guiana',
    'PF': 'French Polynesia',
    'TF': 'French Southern Territories',
    'GA': 'Gabon',
    'GM': 'Gambia',
    'GE': 'Georgia',
    'DE': 'Germany',
    'GH': 'Ghana',
    'GI': 'Gibraltar',
    'GR': 'Greece',
    'GL': 'Greenland',
    'GD': 'Grenada',
    'GP': 'Guadeloupe',
    'GU': 'Guam',
    'GT': 'Guatemala',
    'GN': 'Guinea',
    'GW': 'Guinea-Bissau',
    'GY': 'Guyana',
    'HT': 'Haiti',
    'HM': 'Heard Island and McDonald Islands',
    'VA': 'Holy See (Vatican City State)',
    'HN': 'Honduras',
    'HK': 'Hong Kong',
    'HU': 'Hungary',
    'IS': 'Iceland',
    'IN': 'India',
    'ID': 'Indonesia',
    'IR': 'Iran, Islamic Republic of',
    'IQ': 'Iraq',
    'IE': 'Ireland',
    'IL': 'Israel',
    'IT': 'Italy',
    'JM': 'Jamaica',
    'JP': 'Japan',
    'JO': 'Jordan',
    'KZ': 'Kazakhstan',
    'KE': 'Kenya',
    'KI': 'Kiribati',
    'KP': 'North Korea',
    'KR': 'South Korea',
    'KW': 'Kuwait',
    'KG': 'Kyrgyzstan',
    'LA': 'Lao People\'s Democratic Republic',
    'LV': 'Latvia',
    'LB': 'Lebanon',
    'LS': 'Lesotho',
    'LR': 'Liberia',
    'LY': 'Libya',
    'LI': 'Liechtenstein',
    'LT': 'Lithuania',
    'LU': 'Luxembourg',
    'MO': 'Macao',
    'MG': 'Madagascar',
    'MW': 'Malawi',
    'MY': 'Malaysia',
    'MV': 'Maldives',
    'ML': 'Mali',
    'MT': 'Malta',
    'MH': 'Marshall Islands',
    'MQ': 'Martinique',
    'MR': 'Mauritania',
    'MU': 'Mauritius',
    'YT': 'Mayotte',
    'MX': 'Mexico',
    'FM': 'Micronesia, Federated States of',
    'MD': 'Moldova, Republic of',
    'MC': 'Monaco',
    'MN': 'Mongolia',
    'MS': 'Montserrat',
    'MA': 'Morocco',
    'MZ': 'Mozambique',
    'MM': 'Myanmar',
    'NA': 'Namibia',
    'NR': 'Nauru',
    'NP': 'Nepal',
    'NL': 'Netherlands',
    'NC': 'New Caledonia',
    'NZ': 'New Zealand',
    'NI': 'Nicaragua',
    'NE': 'Niger',
    'NG': 'Nigeria',
    'NU': 'Niue',
    'NF': 'Norfolk Island',
    'MK': 'North Macedonia, Republic of',
    'MP': 'Northern Mariana Islands',
    'NO': 'Norway',
    'OM': 'Oman',
    'PK': 'Pakistan',
    'PW': 'Palau',
    'PS': 'Palestine',
    'PA': 'Panama',
    'PG': 'Papua New Guinea',
    'PY': 'Paraguay',
    'PE': 'Peru',
    'PH': 'Philippines',
    'PN': 'Pitcairn',
    'PL': 'Poland',
    'PT': 'Portugal',
    'PR': 'Puerto Rico',
    'QA': 'Qatar',
    'RE': 'Reunion',
    'RO': 'Romania',
    'RU': 'Russia',
    'RW': 'Rwanda',
    'SH': 'Saint Helena',
    'KN': 'Saint Kitts and Nevis',
    'LC': 'Saint Lucia',
    'PM': 'Saint Pierre and Miquelon',
    'VC': 'Saint Vincent and the Grenadines',
    'WS': 'Samoa',
    'SM': 'San Marino',
    'ST': 'Sao Tome and Principe',
    'SA': 'Saudi Arabia',
    'SN': 'Senegal',
    'SC': 'Seychelles',
    'SL': 'Sierra Leone',
    'SG': 'Singapore',
    'SK': 'Slovakia',
    'SI': 'Slovenia',
    'SB': 'Solomon Islands',
    'SO': 'Somalia',
    'ZA': 'South Africa',
    'GS': 'South Georgia and the South Sandwich Islands',
    'ES': 'Spain',
    'LK': 'Sri Lanka',
    'SD': 'Sudan',
    'SR': 'Suriname',
    'SJ': 'Svalbard and Jan Mayen',
    'SZ': 'Eswatini',
    'SE': 'Sweden',
    'CH': 'Switzerland',
    'SY': 'Syrian Arab Republic',
    'TW': 'Taiwan',
    'TJ': 'Tajikistan',
    'TZ': 'Tanzania, United Republic of',
    'TH': 'Thailand',
    'TL': 'Timor-Leste',
    'TG': 'Togo',
    'TK': 'Tokelau',
    'TO': 'Tonga',
    'TT': 'Trinidad and Tobago',
    'TN': 'Tunisia',
    'TR': 'Turkey',
    'TM': 'Turkmenistan',
    'TC': 'Turks and Caicos Islands',
    'TV': 'Tuvalu',
    'UG': 'Uganda',
    'UA': 'Ukraine',
    'AE': 'United Arab Emirates',
    'US': 'United States of America',
    'UM': 'United States Minor Outlying Islands',
    'UY': 'Uruguay',
    'UZ': 'Uzbekistan',
    'VU': 'Vanuatu',
    'VE': 'Venezuela',
    'VN': 'Vietnam',
    'VG': 'Virgin Islands, British',
    'VI': 'Virgin Islands, U.S.',
    'WF': 'Wallis and Futuna',
    'EH': 'Western Sahara',
    'YE': 'Yemen',
    'ZM': 'Zambia',
    'ZW': 'Zimbabwe',
    'AX': 'Åland Islands',
    'BQ': 'Bonaire, Sint Eustatius and Saba',
    'CW': 'Curaçao',
    'GG': 'Guernsey',
    'IM': 'Isle of Man',
    'JE': 'Jersey',
    'ME': 'Montenegro',
    'BL': 'Saint Barthélemy',
    'MF': 'Saint Martin (French part)',
    'RS': 'Serbia',
    'SX': 'Sint Maarten (Dutch part)',
    'SS': 'South Sudan',
    'XK': 'Kosovo'
  }
};



// WEBPACK FOOTER //
// ./src/data/countries.js